module.exports = __webpack_public_path__ + "roboto-black-webfont.c27df627cdc8c37358a3.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-black-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-black-webfont.woff2
// module chunks = styles